import {isValueStringBetween} from '@colonist/validation'
import {MIN_USERNAME_LENGTH, MAX_USERNAME_LENGTH, MAX_GUEST_USERNAME_LENGTH} from '@colonist/consts'

export function isGuestUsernameLengthValid(text: string): boolean {
    return isValueStringBetween(text, MIN_USERNAME_LENGTH, MAX_GUEST_USERNAME_LENGTH)
}

export function isRegisteredUsernameLengthValid(text: string): boolean {
    return isValueStringBetween(text, MIN_USERNAME_LENGTH, MAX_USERNAME_LENGTH)
}
